import React, { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import { InVenueUsersProvider } from "../../context/useInVenueUsers";
import DispensarioPage from "../Sidebar/DispensarioComponents/DispensarioPage";
import { DEMO_DATA } from "./dispensarioDemoData";

/*
 * Auth-free harness for the wired DispensarioPage at /dev/dispensario.
 * Provides the InVenueUsersProvider the page needs and a scrollable frame that
 * mimics the Layout content area. If a local session token exists it will show
 * real socios/catalogue; otherwise it renders the (empty) "¿A quién atendemos?"
 * hero without crashing. The real page lives at /dispensario inside the shell.
 */
export default function DispensarioDevHarness() {
  const [token, , , venueID] = useContext(UserContext);
  return (
    <InVenueUsersProvider token={token} venueID={venueID}>
      <div style={{ height: "100vh", overflow: "auto", padding: "24px", background: "var(--muted)" }}>
        <DispensarioPage demo={DEMO_DATA} />
      </div>
    </InVenueUsersProvider>
  );
}
